<template>
	<div class="view-toggle" role="group">
		<button type="button" class="toggle-option" :class="{ active: modelValue === Mode.Map }" @click="select(Mode.Map)">
			<AppIcon :name="IconName.Layers" />
			<span>{{ t("view-map") }}</span>
		</button>
		<button
			type="button"
			class="toggle-option"
			:class="{ active: modelValue === Mode.Table }"
			@click="select(Mode.Table)"
		>
			<AppIcon :name="IconName.TableList" />
			<span>{{ t("view-table") }}</span>
		</button>
	</div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import AppIcon from "@/components/AppIcon.vue"
import { IconName } from "@/components/icons/registry"
import { Mode } from "@/model/RootStore"
import { posthogClient } from "@/utils/posthogClient"

defineProps<{
	modelValue: Mode
}>()

const emit = defineEmits<{
	"update:modelValue": [Mode]
}>()

const { t } = useI18n()

function select(mode: Mode): void {
	posthogClient.navigationClicked(mode === Mode.Table ? "view-table" : "view-map")
	emit("update:modelValue", mode)
}
</script>

<style scoped>
.view-toggle {
	display: flex;
	align-items: center;
	gap: var(--spacing-xxs);
	padding: var(--spacing-xxs);
	background-color: var(--neutral-0);
	border-radius: var(--border-radius-full);
	box-shadow: var(--shadow-md);
}

.toggle-option {
	display: flex;
	align-items: center;
	gap: var(--spacing-sm);
	padding: var(--spacing-sm) var(--spacing-lg);
	border: none;
	border-radius: var(--border-radius-full);
	background: transparent;
	color: var(--neutral-600);
	font-family: var(--font-family-primary);
	font-size: var(--font-size-regular);
	font-weight: var(--font-weight-medium);
	white-space: nowrap;
	cursor: pointer;

	&:hover:not(.active) {
		color: var(--neutral-900);
	}

	&.active {
		background-color: var(--primary-green);
		color: var(--neutral-0);
	}
}
</style>
